export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  planSet: 'pricing-11',
  growthbookFeatures: ['supp', 'thankyou_tips'],
};
